import "core-js/modules/es6.function.name";
import "core-js/modules/es6.array.filter";
import "core-js/modules/es6.array.reduce";
import "core-js/modules/es6.function.bind";
import "core-js/modules/es6.array.for-each";
import "core-js/modules/es6.object.define-property";

var _this4 = this;

function _newArrowCheck(innerThis, boundThis) {
  if (innerThis !== boundThis) {
    throw new TypeError("Cannot instantiate an arrow function");
  }
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

import isEqual from "lodash/isEqual";
import { Events } from "./Events";
var Visibility;

(function (Visibility) {
  Visibility[Visibility["FULLY_VISIBLE"] = 0] = "FULLY_VISIBLE";
  Visibility[Visibility["TOP_CLIPPED"] = 1] = "TOP_CLIPPED";
  Visibility[Visibility["BOTTOM_CLIPPED"] = 2] = "BOTTOM_CLIPPED";
})(Visibility || (Visibility = {}));

var ScrollEvents =
/*#__PURE__*/
function () {
  function ScrollEvents() {
    _classCallCheck(this, ScrollEvents);
  }

  _createClass(ScrollEvents, null, [{
    key: "runCallbacks",
    value: function runCallbacks() {
      var _this = this;

      ScrollEvents.events.setRunning();
      ScrollEvents.visibilityCallbacks.forEach(function (callbackObject) {
        _newArrowCheck(this, _this);

        var callback = callbackObject.callback,
            elementIdsToWatch = callbackObject.elementIdsToWatch,
            offset = callbackObject.offset,
            lastResult = callbackObject.lastResult,
            visibility = callbackObject.visibility;

        if (!elementIdsToWatch) {
          callback();
        } else {
          var result = ScrollEvents.isElementInViewport(elementIdsToWatch, visibility, offset);

          if (!isEqual(result, lastResult)) {
            callbackObject.lastResult = result;
            callback(result);
          }
        }
      }.bind(this));
      ScrollEvents.scrollCallbacks.forEach(function (callback) {
        _newArrowCheck(this, _this);

        return callback();
      }.bind(this));
    }
    /**
     * this function takes in an array of elementIds. Those DOM elements that fulfill the Visibility
     * criterion (Visibility is an enum see above) are returned in an array.
     * You can move the visibility to the top or buttom by a number of pixels by using the offset parameter
     */

  }, {
    key: "isElementInViewport",
    value: function isElementInViewport(elementIds, visibility) {
      var _this2 = this;

      var offset = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
      var result = elementIds.reduce(function (acc, id) {
        var _this3 = this;

        _newArrowCheck(this, _this2);

        var target = document.getElementById(id);

        if (!target) {
          return acc;
        }

        var stickyElementsHeight = ScrollEvents.stickyElements.reduce(function (res, curr) {
          _newArrowCheck(this, _this3);

          return res + curr.elm.offsetHeight;
        }.bind(this), 0);
        var offsetTopUpperEdge = target.getBoundingClientRect().top - offset - stickyElementsHeight;
        var offsetBottomUpperEdge = target.getBoundingClientRect().bottom - offset - stickyElementsHeight;
        var offsetTopLowerEdge = typeof window !== "undefined" ? target.getBoundingClientRect().top - window.innerHeight : 0;
        var offsetBottomLowerEdge = typeof window !== "undefined" ? target.getBoundingClientRect().bottom - window.innerHeight : 0;

        if (visibility === Visibility.TOP_CLIPPED) {
          var isInTarget = offsetTopUpperEdge < 0 && offsetBottomUpperEdge > 0;
          var isAbove = offsetTopUpperEdge < 0 && offsetBottomUpperEdge < 0;
          var isBelow = offsetTopUpperEdge > 0 && offsetBottomUpperEdge > 0;

          if (isInTarget) {
            acc.targetIds.push(id);
          } else if (isAbove) {
            acc.idsAbove.push(id);
          } else if (isBelow) {
            acc.idsBelow.push(id);
          }
        } else if (visibility === Visibility.BOTTOM_CLIPPED) {
          var _isInTarget = offsetTopLowerEdge < 0 && offsetBottomLowerEdge > 0;

          var _isAbove = offsetTopLowerEdge < 0 && offsetBottomLowerEdge < 0;

          var _isBelow = offsetTopLowerEdge > 0 && offsetBottomLowerEdge > 0;

          if (_isInTarget) {
            acc.targetIds.push(id);
          } else if (_isAbove) {
            acc.idsAbove.push(id);
          } else if (_isBelow) {
            acc.idsBelow.push(id);
          }
        } else if (offsetTopUpperEdge > 0 && offsetBottomLowerEdge < 0) {
          acc.targetIds.push(id);
        } // return ;


        return acc;
      }.bind(this), {
        targetIds: [],
        idsAbove: [],
        idsBelow: []
      });

      if (result.targetIds.length > 0) {
        return result.targetIds;
      }

      if (result.idsAbove.length > 0 && result.idsBelow.length > 0) {
        return [result.idsAbove[result.idsAbove.length - 1]];
      }

      return [];
    }
  }]);

  return ScrollEvents;
}(); // tslint:disable member-ordering


ScrollEvents.events = new Events("scroll", ScrollEvents.runCallbacks);
ScrollEvents.scrollCallbacks = [];
ScrollEvents.visibilityCallbacks = [];
ScrollEvents.stickyElements = [];
ScrollEvents.stickyElementsHeight = 0;
/**
 * registers a callback function for a scroll event
 * After registering, the callback function(s) are executed
 */

ScrollEvents.addScrollCallback = function (callback) {
  _newArrowCheck(this, _this4);

  ScrollEvents.scrollCallbacks.push(callback);
  ScrollEvents.runCallbacks();
}.bind(this);
/**
 * registers a callback function for a visiblility CHANGE event
 * -> i.e. if one or more DOM elements (elementIdsToWatch) move in or out of the Viewport.
 * Visibility is the kind of visiblility (top, bottom, fully visible)
 * You can move the visibility to the top or buttom by a number of pixels by using the offset parameter
 * After registering, the callback function(s) are executed.
 *      -> If the elementId(s) is/are visible in the first place, the visibilityCallback will run with "visible=true"
 *      -> So if a Media component (autoplay=true) is visible in the Viewport in the first place, the video will run.
 */


ScrollEvents.addVisibilityCallback = function (callback, elementIdsToWatch, visibility, offset) {
  _newArrowCheck(this, _this4);

  ScrollEvents.visibilityCallbacks.push({
    callback: callback,
    elementIdsToWatch: elementIdsToWatch,
    visibility: visibility,
    offset: offset,
    lastResult: undefined
  });
  ScrollEvents.runCallbacks();
}.bind(this);

ScrollEvents.addStickyElement = function (name, elm) {
  _newArrowCheck(this, _this4);

  ScrollEvents.stickyElements.push({
    name: name,
    elm: elm
  });
  ScrollEvents.stickyElementsHeight += elm.offsetHeight;
  ScrollEvents.runCallbacks();
}.bind(this);

ScrollEvents.getStickyElements = function () {
  _newArrowCheck(this, _this4);

  return ScrollEvents.stickyElements;
}.bind(this);

ScrollEvents.getStickyElementsHeight = function () {
  _newArrowCheck(this, _this4);

  return ScrollEvents.stickyElementsHeight;
}.bind(this);

ScrollEvents.removeStickyElement = function (name) {
  var _this5 = this;

  _newArrowCheck(this, _this4);

  ScrollEvents.stickyElements = ScrollEvents.stickyElements.filter(function (curr) {
    _newArrowCheck(this, _this5);

    if (curr.name === name) {
      ScrollEvents.stickyElementsHeight -= curr.elm.offsetHeight;
    }

    return curr.name !== name;
  }.bind(this));
}.bind(this);

ScrollEvents.removeScrollCallback = function (callback) {
  var _this6 = this;

  _newArrowCheck(this, _this4);

  return ScrollEvents.scrollCallbacks = ScrollEvents.scrollCallbacks.filter(function (c) {
    _newArrowCheck(this, _this6);

    return c !== callback;
  }.bind(this));
}.bind(this);

ScrollEvents.removeVisibilityCallback = function (callback) {
  var _this7 = this;

  _newArrowCheck(this, _this4);

  return ScrollEvents.visibilityCallbacks = ScrollEvents.visibilityCallbacks.filter(function (c) {
    _newArrowCheck(this, _this7);

    return c.callback !== callback;
  }.bind(this));
}.bind(this);

export { ScrollEvents, Visibility };